export const getFileTypeIcon = (type: any) => {
  switch (type) {
    case 'pdf': {
      return 'filePdf';
    }
    case 'image/jpeg':
    case 'image/png':
    case 'image/webp': {
      return 'fileImage';
    }
    case 'video/avi':
    case 'video/mov': {
      return 'fileVideo';
    }
  }
};
